import { useState, useEffect } from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import { ConfigProvider } from 'antd';
import Layout from './components/Layout';
import Login from './components/Login';
import NotFound from './pages/NotFound';
import {createData, getData} from "./api/api";
import Merchants from "./pages/Merchants";
import StaticQrs from "./pages/StaticQrs";
import BankAccounts from "./pages/BankAccounts";
import Terminals from "./pages/Terminals";
import TransactionQrs from "./pages/TransactionQrs";
import Users from "./pages/Users";
import Dashboard from "./pages/Dashboard";
import 'antd/dist/reset.css';
import ruLocale from 'antd/es/locale/ru_RU';
import enLocale from 'antd/es/locale/en_US';
import uzLocale from 'antd/es/locale/uz_UZ';
import { useTranslation } from 'react-i18next';
function App() {
    const [authenticated, setAuthenticated] = useState(!!localStorage.getItem('accessToken'));
    const [loading, setLoading] = useState(true);
    const [currentUser, setCurrentUser] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isMerchant, setIsMerchant] = useState(false);

    const { i18n } = useTranslation();
    const antdLocale = { en: enLocale, ru: ruLocale, uz: uzLocale }[i18n.language] || ruLocale;

    const routes= [
        {
            path:"/",
            element: <Dashboard isAdmin={isAdmin} isMerchant={isMerchant}/>
        },

        {
            path:"/merchants",
            element: isAdmin  ? <Merchants isAdmin={isAdmin}/>  : <NotFound/>
        },
        {
            path:"/bank-accounts",
            element: isAdmin || isMerchant ? <BankAccounts isAdmin={isAdmin} isMerchant={isMerchant}/>: <NotFound/>
        },
        {
            path:"/terminals",
            element: <Terminals isAdmin={isAdmin} isMerchant={isMerchant}/>
        },
        {
            path:"/static-qr",
            element: <StaticQrs isAdmin={isAdmin} isMerchant={isMerchant}/>
        },
        {
            path:"/transactions-qr",
            element: <TransactionQrs isAdmin={isAdmin} isMerchant={isMerchant}/>
        },
        {
            path:"/users",
            element: isAdmin ? <Users isAdmin={isAdmin}/> : <NotFound/>
        }
    ]

    const checkAuth = async () => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            try {
                const response = await createData("/user/get-current-user", null);

                if (response?.data?.success) {
                    setAuthenticated(true);
                    const user = response?.data?.data;
                    const role = user.roles.includes("ROLE_ADMIN")
                        ? 'ROLE_ADMIN'
                        : user.roles.includes("ROLE_MERCHANT")
                            ? 'ROLE_MERCHANT'
                            : user.roles.includes("ROLE_MERCHANT_USER")
                                ? 'ROLE_MERCHANT_USER'
                                : null;
                    if (role) {
                        setIsAdmin(role === 'ROLE_ADMIN');
                        setIsMerchant(role === 'ROLE_MERCHANT');
                        setCurrentUser(user);
                    } else {
                        console.error('User role not found');
                        alert('User role not found');
                        localStorage.removeItem('accessToken');
                        setAuthenticated(false);
                    }
                } else {
                    console.error('API success false');
                    localStorage.removeItem('accessToken');
                    setAuthenticated(false);
                }
            } catch (error) {
                console.error('API error:', error);
                localStorage.removeItem('accessToken');
                setAuthenticated(false);
            }
        } else {
            console.error('No access token found');
            setAuthenticated(false);
        }
        setLoading(false);
    };

    useEffect(() => {
        checkAuth();
    }, []);

    if (loading) {
        return <div>Yuklanmoqda...</div>;
    }

    if (!authenticated) {
        return <Login setAuthenticated={setAuthenticated} />;
    }
    return (
        <ConfigProvider locale={antdLocale}>
        <BrowserRouter>
            <Layout currentUser={currentUser} isAdmin={isAdmin} isMerchant={isMerchant}>
                <Routes>
                    {
                        routes.map(value =>
                            <Route path={value.path} element={value.element} />
                        )
                    }
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Layout>
        </BrowserRouter>
        </ConfigProvider>
    );
}

export default App;